import { colors } from 'modules/app/styles'
import styled, { css } from 'styled-components'

export const PageListUL = styled.ul`
  position: relative;
  margin-bottom: 0;
  margin: 0;
  ${(props) => {
    if (props.level > 0) {
      return css`
        margin-left: ${props.level * 30}px;
      `
    }
  }}
  li {
    position: relative;
    padding: 8px 10px;
    ${(props) => {
      if (props.type === 'response') {
        return css`
          margin-top: 0;
        `
      }
    }}
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:first-of-type {
      margin-top: 0;
    }
    &.with-page-meta {
      margin-top: 0px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e3e7f0;
      &:last-of-type {
        border-bottom: none;
      }
    }
    .content-link {
      width: 100%;
      cursor: pointer;
      &:hover,
      &.active {
        color: ${colors['main-blue']};
      }
      .page-title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: normal;
      }
    }
    .more-button-dropdown {
      position: absolute;
      right: 8px;
      pointer-events: all;
      button.toggle {
        background: ${colors['light-blue-100']};
        border-radius: 20px;
        padding: 5px;
        width: 24px;
        height: 24px;
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }
    &:hover .more-button-dropdown button.toggle {
      display: flex;
    }

    // Freemium disabled
    &.disabled {
      padding: 5px;
      margin: 8px 0;
      pointer-events: none;
      .show-upgrade-button {
        display: flex;
      }
    }
  }
`
export const EmptyPlaceholder = styled.div`
  svg {
    fill: ${colors['main-text']};
    width: 18px;
    height: 18px;
  }
`

export const Badge = styled.span`
  background: #f3a0ae;
  padding: 1px 7px;
  margin-left: 10px;
  color: #fff;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: 0.6px;
  &.blue {
    background: ${colors['main-blue']};
  }
  &.green {
    background: ${colors['green']};
  }
`

export const FooterButtons = styled.div``

export const DeletePageCategoryForm = styled.div`
  display: flex;
  align-items: center;
  &.level-1 {
    padding: 15px 8px;
    border-bottom: 1px solid #e3e7f0;
  }
  &.level-2 {
    margin-left: 30px;
  }
  &.level-3 {
    margin-left: 60px;
  }
`

export const EmptyResult = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100%;
  .emptyIcon {
    text-align: center;
    svg {
      max-width: 80%;
    }
  }
`
